export default __webpack_public_path__ + "static/media/ib-logo.c4af95e6.png";